import { useEffect } from 'react'

import { useAppDispatch } from '@/redux/rootReducer'
import { getStunServer } from '@/redux/reducers/consultation.reducer'
import { getCustomDevices } from '@/redux/reducers/custom-device.reducer'

export function usePageSetup() {
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(getCustomDevices())
    dispatch(getStunServer())
  }, [dispatch])
}
